import cx from 'clsx';
import React, { memo } from 'react';

import styles from '@/components/Header/HeaderSlot.module.scss';
import { HeaderItem } from '@/components/Header/types';
import { isEqual } from '@/utils/lodash-alternatives';

import { createRel } from './utils';

interface ExternalItemProps {
  item: HeaderItem;
}

const ExternalItem: React.FC<ExternalItemProps> = memo(
  ({ item }) => (
    <a
      className={cx(
        styles.title,
        item.state === 'active' && styles.titleActive
      )}
      data-testid="header-slot-external"
      rel={createRel()}
      href={item.url || ''}
      target={item.target || ''}
    >
      {item.title}
    </a>
  ),
  (prevProps: ExternalItemProps, nextProps: ExternalItemProps) =>
    isEqual(prevProps, nextProps)
);

export default ExternalItem;
